module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image23.b8eb4274.jpg";